import React from 'react';
import { IndicationContent, INDICATION_TYPES } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from '../reviewEvents.module.scss';

export const SessionTokenExpiredModal = ({ onExit }) => {
    return (
        <>
            <div className={styles['container']}>
                <div className={styles['title']}>
                    <FormattedMessage
                        id="codeless.session.token.expired.title"
                        defaultMessage="The token has expired"
                    />
                </div>
            </div>
            <div className={styles['error-indication']}>
                <IndicationContent
                    type={INDICATION_TYPES.ERROR}
                    contentClassName={styles['error-indication-message']}
                    displayIcon
                >
                    <FormattedMessage
                        id="codeless.session.token.expired.text"
                        defaultMessage="Your session token has expired. Please exit this tab and return to the main page to start over."
                    />
                </IndicationContent>
            </div>
            <div className={styles['error-actions']} />
        </>
    );
};
